import React from 'react';
import PropTypes from 'prop-types';
import Headline from '@components/atoms/headline/headline';
import EducationTime from '@components/atoms/education/time/educationTime';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';
import Link from 'next/link';
import Copy from '@components/atoms/copy/copy';
import StyledEducationQuickFact from './educationQuickFact.style';

const EducationQuickFact = ({ title, copy, duration, personCount, links }) => {
  return (
    <StyledEducationQuickFact>
      <Headline className="quick-fact__headline">{title}</Headline>
      <div className="quick-fact__content">
        {duration && <EducationTime value={duration} />}
        {personCount && <Copy className="quick-fact__person-copy">{personCount}</Copy>}
        {copy && <MixedCopy className="quick-fact__copy" fullWidth html={copy} />}
        {links &&
          links.map(link => (
            <>
              {link.type === 'educationExternalLink' && (
                <Link
                  key={link.id}
                  href={link.educationExternalLink}
                  target="_blank"
                  className="quick-fact__link"
                >
                  <span className="quick-fact__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      width="20"
                      height="20"
                      viewBox="0 0 23 23"
                    >
                      <path
                        fill="currentColor"
                        d="M8.01 4c-.18 0-.34.16-.36.36l.03 1.46c-.01.2.15.36.37.36l6.28.03c.33 0 .5.42.26.65L4.11 17.35a.35.35 0 0 0 0 .5l1.04 1.04c.14.15.36.15.5 0L16.14 8.41c.23-.23.63-.09.63.24l.05 6.3c0 .18.16.35.36.37h1.44c.22.01.38-.15.38-.37l-.06-7.92c-.03-.5-.21-.96-.56-1.3l-1.1-1.11a1.96 1.96 0 0 0-1.3-.56L8 4Z"
                      />
                    </svg>
                  </span>
                  <span>{link.educationExternalLinkTitle}</span>
                </Link>
              )}
              {link.type === 'educationDownloadLink' && (
                <a
                  href={link.educationDownloadLink.src}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="quick-fact__link-inner"
                >
                  <span className="quick-fact__icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 23 23"
                    >
                      <path
                        fill="currentColor"
                        d="M2.5 9.56c0-.52.43-.93.94-.93H5.7v2.68c0 .83.68 1.5 1.51 1.5h8.63a1.5 1.5 0 0 0 1.49-1.5V8.63h2.26c.51 0 .93.41.93.93v7.11c0 .52-.42.96-.94.96H3.44a.94.94 0 0 1-.94-.95V9.56ZM15.81 1.5v9.81H7.2v-9.8h8.61Zm0 20H7.2v-2.31h8.61v2.3ZM2.88 19.13H5.7l-.02.06v2.3c0 .84.69 1.51 1.52 1.51h8.63a1.5 1.5 0 0 0 1.49-1.5v-2.37h1.78c.5 0 .98-.2 1.34-.56l1.02-1.02c.35-.36.54-.84.54-1.34V9c0-1.04-.83-1.88-1.87-1.88H17.3V1.5c0-.83-.66-1.5-1.49-1.5H7.2c-.83 0-1.52.67-1.52 1.5v5.62h-2.8C1.84 7.12 1 7.96 1 9v8.25c0 1.03.84 1.88 1.88 1.88"
                      />
                    </svg>
                  </span>
                  <span>{link.educationDownloadLink.title}</span>
                </a>
              )}
            </>
          ))}
        {!copy && !duration && !personCount && links.length === 0 && <p>-</p>}
      </div>
    </StyledEducationQuickFact>
  );
};

EducationQuickFact.propTypes = {
  title: PropTypes.string.isRequired,
  copy: PropTypes.string,
  personCount: PropTypes.number,
  duration: PropTypes.number,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      type: PropTypes.string,
      educationExternalLink: PropTypes.string,
      educationExternalLinkTitle: PropTypes.string,
      educationLinks: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          src: PropTypes.string
        })
      )
    })
  )
};

export default EducationQuickFact;
